<style lang="stylus">
    @import '../../assets/css/theme.styl'
    .order {
        .van-collapse-item {
            .van-cell {
                background-color: baseConBackColor
                &:after {
                    border-color: #454545
                }
            }
            .van-collapse-item__content {
                background-color: baseConBackColor
            }
            .van-cell__title {
                color: #fff
            }
            .van-cell__value {
                flex: none
            }
        }
    }
</style>
<style scoped lang="stylus">
    @import '../../assets/css/theme.styl'
    .order {
        padding 0 10px
        .van-collapse {
            &:after {
                border none
            }
        }
        .van-collapse-item {
            margin-bottom: 10px
            border-radius 4px
            overflow hidden
            &:after {
                border none
            }
        }
        .item {
            span {
                font-size: 14px
            }
            .stone {
                border 1px solid #14AFD8
                color: #14AFD8
                padding 3px 8px
                font-size: 12px
            }
            .money {
                color: #80DCBB
                margin 0 14px
            }
            .state {
                font-size: 12px
                padding 3px 8px
                color: #fff
                &.no-check {
                    background rgba(244, 136, 41, .5)
                }
                &.check {
                    background: rgba(140, 255, 126, .5)
                }
            }

            .con {
                li {
                    &:not(:last-child) {
                        margin-bottom: 8px
                    }
                    & > div {
                        background-color: #283240
                        border-radius 4px
                        &:not(:last-child) {
                            margin-right: 4px
                        }
                        padding 8px 0
                        text-align center
                        .title {
                            color: #D2D2D2
                            margin-right: 8px
                        }
                        .val {
                            color: #fff
                        }
                    }
                }
            }
        }
    }
</style>

<template>
    <div class="order cus-cell">
        <QuickTime :is-quick-time="isQuickTime" @time-change="kTimeChange"/>
        <van-cell :title="timeTips" class="time-tips no_border"/>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
        >
            <van-collapse v-model="activeName" accordion>
                <van-collapse-item v-for="(item, index) in list" :title="item.factory_name" :name="index" :key="index"
                                   class="item">
                    <div slot="value">
                        <span class="stone">{{item.stone_name}}</span>
                        <span class="money">{{item.money}}</span>
                        <span class="state" :class="item.check_status == checkStateMap.check ? 'check' : 'no-check'">{{checkState[item.check_status]}}</span>
                    </div>
                    <ul class="con">
                        <li data-flex="box:mean">
                            <div>
                                <span class="title">车牌号</span>
                                <span class="val">{{item.plate_number}}</span>
                            </div>
                            <div>
                                <span class="title">单价</span>
                                <span class="val">{{item.price}}</span>
                            </div>
                        </li>
                        <li data-flex="box:mean">
                            <div>
                                <span class="title">皮重</span>
                                <span class="val">{{item.tare_weight}}</span>
                            </div>
                            <div>
                                <span class="title">毛重</span>
                                <span class="val">{{item.gross_weight}}</span>
                            </div>
                            <div>
                                <span class="title">净重</span>
                                <span class="val">{{item.net_weight}}</span>
                            </div>
                        </li>
                        <li>
                            <div>
                                <span class="title">结算时间</span>
                                <span class="val">{{item.settlement_time}}</span>
                            </div>
                        </li>
                        <li>
                            <div>
                                <span class="title">核验人</span>
                                <span class="val">{{item.check_operator_name}} {{item.check_time}}</span>
                            </div>
                        </li>
                    </ul>
                </van-collapse-item>
            </van-collapse>
        </van-list>

        <OrderFilter ref="orderFilter" @filter-change="filterChange" :isFactory="isFactory"/>
    </div>
</template>

<script>
    import {getList} from "@/service/order";
    import {CHECK_STATE_MAP, CHECK_STATE} from "@/config";
    import OrderFilter from './components/Filter'
    import QuickTime from '@/components/QuickTime'
    import _ from 'lodash'
    import {mapState} from "vuex";

    export default {
        props: [],
        components: {
            OrderFilter,
            QuickTime,
        },
        data() {
            return {
                activeName: '',
                list: [],
                checkState: CHECK_STATE,
                checkStateMap: CHECK_STATE_MAP,

                loading: false,
                finished: false,

                page: {
                    page: 1,
                    list_rows: 15,
                },
                searchForm: {
                    settlement_time: '',
                    factory_id: '',
                },
                isQuickTime: true,
                dayType: '',
            };
        },
        created() {
            // this.getList()
        },
        mounted() {
            this.$eventHub.$on('click-right', () => {
                this.$refs.orderFilter.show(this.isQuickTime)
            })
        },
        computed: {
            ...mapState({
                factoryId: state => state.userInfo.factory_id
            }),
            isFactory() {
                return this.factoryId > 0
            },
            searchTimeList() {
                return this.searchForm.settlement_time.split(' - ')
            },
            timeTips() {
                return this.isQuickTime && this.dayType == 'day' ? `${this.searchTimeList[0]} - 目前` : this.searchForm.settlement_time
            },
        },
        watch: {},
        methods: {
            async getList() {
                let form = Object.assign({}, this.page, this.searchForm)
                if (this.isFactory) form.factory_id = this.factoryId
                this.loading = true
                let res = await getList(form)
                this.loading = false
                if (res.status) {
                    if (res.data.last_page <= this.page.page) {
                        this.finished = true;
                    } else {
                        ++this.page.page;
                    }
                    this.list.push(...res.data.data);
                }
            },
            onLoad() {
                this.getList()
            },
            search() {
                this.finished = false
                this.list = []
                this.page.page = 1
                this.getList()
            },
            filterChange(searchForm) {
                console.log(searchForm, 'searchForm');
                if (searchForm.settlement_time) {
                    this.isQuickTime = false
                    this.searchForm = searchForm
                    this.dayType = ''
                } else {
                    this.searchForm = Object.assign({}, this.searchForm, _.omit(searchForm, ['settlement_time']))
                }
                this.search()
            },
            kTimeChange({time, type}) {
                this.dayType = type
                this.isQuickTime = true
                this.searchForm.settlement_time = time
                this.search()
            },
        },

        destroyed() {
            this.$eventHub.$off()
        },
    };
</script>
